/* eslint-disable import/first */
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  require('preact/debug');
}

import { h, render } from 'preact';
import Newsletter from '../components/marketing/Newsletter';

document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('#newsletter-modal');
  const popupButton = document.querySelectorAll('button[data-newsletter-trigger]');
  const urlSearchParams = new URLSearchParams(window.location.search);
  const openRedirect = urlSearchParams.get('open_newsletter_signup');

  if (popupButton) {
    popupButton.forEach((el) => {
      el.addEventListener('click', () => {
        dialog.showModal();
      });
    });
  }

  window.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });

  if (openRedirect && !window.SlrsIdentify?.accepts_marketing && !window.SlrsIdentify?.accepts_marketing) {
    dialog.showModal();
  }
});

render(<Newsletter />, document.querySelector('body'));
